module.exports = __webpack_public_path__ + "assets/img/ozmo-agencia-innovacion-organizacional.7bc2c249.png";